import { Grid } from '@mui/material';
import styled from 'styled-components';

export const Container = styled(Grid)(() => ({
    width: '100vw',
    paddingBottom: 16
}));